module.exports = __webpack_public_path__ + "img/iost.c5386ede.svg";